import { FE_DOMAINS } from "../constants/fe-domains";

export const getCountryFromDomain = () => {
  const domain = window.location.hostname;

  switch (domain) {
    case FE_DOMAINS.SAU:
      return "SAU";
    case FE_DOMAINS.ARE:
      return "ARE";
    case FE_DOMAINS.PAK:
      return "PAK";
    case FE_DOMAINS.OMN:
      return "OMN";
    case FE_DOMAINS.EGY:
      return "EGY";
    case FE_DOMAINS.ALPHA:
      return "EGY";
    case FE_DOMAINS.BETA:
      return "ARE";
    default:
      return "EGY";
  }
}